import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'left',
  },
  title: {
    fontWeight: 400,
    fontSize: 22,
    marginTop: 0,
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1.2),
    alignSelf: 'flex-start',
    ...theme.headerFont,
  },
  gridRoot: {
    width: '100%',
    '& > div': {
      padding: theme.spacing(1),
    }
  },
  submitBtn: {
    width: '100%',
    maxWidth: 300,
    height: 50,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'none',
    }
  },
  submitBtnFull: {
    height: 50,
  },
  noPaddingNoMargin: {
    margin: '0 !important',
    padding: '0 !important',
  },
}))

export default useStyles